import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import { CreateUserDialog } from "../../../shared/CreateUserDialog";
import { usePrivacyNavigate } from "../../../shared/usePrivacyNavigate";
import { DynamicGrid } from "../../../dynamicGrid";
import { PageTitle } from "../../../shared/Page";
import { useScimEditingMode } from "../shared/useScimEditingMode";

export const UserGridToolbar: FC = () => {
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();
  const { isScimEnabled } = useScimEditingMode();

  return (
    <DynamicGrid.Toolbar
      pageTitle={<PageTitle title={t("User.Grid.Title")} subTitle={t("User.Grid.SubTitle")} />}
      actionButtons={
        <>
          <DynamicGrid.ExportButton />
          {!isScimEnabled && (
            <DynamicGrid.CreateNewButton
              labelKey="CreateUser.Button"
              renderDialog={({ onClose }) => (
                <CreateUserDialog
                  defaultEmail=""
                  onCancel={onClose}
                  onCreated={userId => navigate(paths.userById(userId))}
                />
              )}
            />
          )}
        </>
      }
    />
  );
};
